var map = {
	"./appsgoogle_gmail.svg": "../mindplot/assets/icons/appsgoogle_gmail.svg",
	"./appsgoogle_maps.svg": "../mindplot/assets/icons/appsgoogle_maps.svg",
	"./appsgoogle_youtube.svg": "../mindplot/assets/icons/appsgoogle_youtube.svg",
	"./arrow_merge.svg": "../mindplot/assets/icons/arrow_merge.svg",
	"./bullet_black.png": "../mindplot/assets/icons/bullet_black.png",
	"./bullet_blue.png": "../mindplot/assets/icons/bullet_blue.png",
	"./bullet_green.png": "../mindplot/assets/icons/bullet_green.png",
	"./bullet_orange.png": "../mindplot/assets/icons/bullet_orange.png",
	"./bullet_pink.png": "../mindplot/assets/icons/bullet_pink.png",
	"./bullet_purple.png": "../mindplot/assets/icons/bullet_purple.png",
	"./bullet_red.png": "../mindplot/assets/icons/bullet_red.png",
	"./chart_curve.svg": "../mindplot/assets/icons/chart_curve.svg",
	"./chart_line.svg": "../mindplot/assets/icons/chart_line.svg",
	"./chart_organisation.svg": "../mindplot/assets/icons/chart_organisation.svg",
	"./chart_pie.svg": "../mindplot/assets/icons/chart_pie.svg",
	"./close.svg": "../mindplot/assets/icons/close.svg",
	"./conn_connect.png": "../mindplot/assets/icons/conn_connect.png",
	"./conn_disconnect.png": "../mindplot/assets/icons/conn_disconnect.png",
	"./flag_blue.svg": "../mindplot/assets/icons/flag_blue.svg",
	"./flag_green.svg": "../mindplot/assets/icons/flag_green.svg",
	"./flag_orange.svg": "../mindplot/assets/icons/flag_orange.svg",
	"./flag_pink.svg": "../mindplot/assets/icons/flag_pink.svg",
	"./flag_purple.svg": "../mindplot/assets/icons/flag_purple.svg",
	"./flag_yellow.svg": "../mindplot/assets/icons/flag_yellow.svg",
	"./hard_drive_cd.svg": "../mindplot/assets/icons/hard_drive_cd.svg",
	"./hard_ipod.svg": "../mindplot/assets/icons/hard_ipod.svg",
	"./hard_skull.svg": "../mindplot/assets/icons/hard_skull.svg",
	"./links.svg": "../mindplot/assets/icons/links.svg",
	"./meetapps_facebook-messenger.svg": "../mindplot/assets/icons/meetapps_facebook-messenger.svg",
	"./meetapps_google-meet.svg": "../mindplot/assets/icons/meetapps_google-meet.svg",
	"./meetapps_ms-teams.svg": "../mindplot/assets/icons/meetapps_ms-teams.svg",
	"./meetapps_slack.svg": "../mindplot/assets/icons/meetapps_slack.svg",
	"./meetapps_whatapp.svg": "../mindplot/assets/icons/meetapps_whatapp.svg",
	"./meetapps_zoom.svg": "../mindplot/assets/icons/meetapps_zoom.svg",
	"./money_dollar.svg": "../mindplot/assets/icons/money_dollar.svg",
	"./money_ruby.svg": "../mindplot/assets/icons/money_ruby.svg",
	"./notes.svg": "../mindplot/assets/icons/notes.svg",
	"./object_music.svg": "../mindplot/assets/icons/object_music.svg",
	"./onoff_add.svg": "../mindplot/assets/icons/onoff_add.svg",
	"./onoff_delete.svg": "../mindplot/assets/icons/onoff_delete.svg",
	"./onoff_status_offline.png": "../mindplot/assets/icons/onoff_status_offline.png",
	"./onoff_status_offline.svg": "../mindplot/assets/icons/onoff_status_offline.svg",
	"./onoff_status_online.png": "../mindplot/assets/icons/onoff_status_online.png",
	"./onoff_status_online.svg": "../mindplot/assets/icons/onoff_status_online.svg",
	"./sign_cancel.svg": "../mindplot/assets/icons/sign_cancel.svg",
	"./sign_closed.svg": "../mindplot/assets/icons/sign_closed.svg",
	"./sign_exclamation.svg": "../mindplot/assets/icons/sign_exclamation.svg",
	"./sign_help.svg": "../mindplot/assets/icons/sign_help.svg",
	"./sign_info.svg": "../mindplot/assets/icons/sign_info.svg",
	"./sign_warning.svg": "../mindplot/assets/icons/sign_warning.svg",
	"./social_facebook.svg": "../mindplot/assets/icons/social_facebook.svg",
	"./social_google-plus.svg": "../mindplot/assets/icons/social_google-plus.svg",
	"./social_instagram.svg": "../mindplot/assets/icons/social_instagram.svg",
	"./social_redit.svg": "../mindplot/assets/icons/social_redit.svg",
	"./social_twitter.svg": "../mindplot/assets/icons/social_twitter.svg",
	"./soft_cursor.svg": "../mindplot/assets/icons/soft_cursor.svg",
	"./soft_database.svg": "../mindplot/assets/icons/soft_database.svg",
	"./soft_database_table.svg": "../mindplot/assets/icons/soft_database_table.svg",
	"./soft_feed.svg": "../mindplot/assets/icons/soft_feed.svg",
	"./soft_folder_explore.svg": "../mindplot/assets/icons/soft_folder_explore.svg",
	"./soft_penguin.svg": "../mindplot/assets/icons/soft_penguin.svg",
	"./soft_rss.svg": "../mindplot/assets/icons/soft_rss.svg",
	"./tag_blue.svg": "../mindplot/assets/icons/tag_blue.svg",
	"./tag_green.svg": "../mindplot/assets/icons/tag_green.svg",
	"./tag_orange.svg": "../mindplot/assets/icons/tag_orange.svg",
	"./tag_pink.svg": "../mindplot/assets/icons/tag_pink.svg",
	"./tag_purple.svg": "../mindplot/assets/icons/tag_purple.svg",
	"./tag_red.svg": "../mindplot/assets/icons/tag_red.svg",
	"./tag_white.svg": "../mindplot/assets/icons/tag_white.svg",
	"./tag_yellow.svg": "../mindplot/assets/icons/tag_yellow.svg",
	"./task_0.svg": "../mindplot/assets/icons/task_0.svg",
	"./task_100.svg": "../mindplot/assets/icons/task_100.svg",
	"./task_25.svg": "../mindplot/assets/icons/task_25.svg",
	"./task_50.svg": "../mindplot/assets/icons/task_50.svg",
	"./task_75.svg": "../mindplot/assets/icons/task_75.svg",
	"./things_address_book.svg": "../mindplot/assets/icons/things_address_book.svg",
	"./things_bubbles.svg": "../mindplot/assets/icons/things_bubbles.svg",
	"./things_skull.svg": "../mindplot/assets/icons/things_skull.svg",
	"./things_window-layout.svg": "../mindplot/assets/icons/things_window-layout.svg",
	"./things_wrench.svg": "../mindplot/assets/icons/things_wrench.svg",
	"./time_calendar.svg": "../mindplot/assets/icons/time_calendar.svg",
	"./time_clock.svg": "../mindplot/assets/icons/time_clock.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../mindplot/assets/icons sync \\.(png%7Csvg)$";